import { render, staticRenderFns } from "./LocationHome.vue?vue&type=template&id=a98962de&scoped=true&"
import script from "./LocationHome.vue?vue&type=script&lang=js&"
export * from "./LocationHome.vue?vue&type=script&lang=js&"
import style0 from "./LocationHome.vue?vue&type=style&index=0&id=a98962de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98962de",
  null
  
)

export default component.exports